module.exports = __webpack_public_path__ + "img/crew_adv_06.9c14f720.png";